import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

/**
 * Lease Article Principal Repayment Schedule(LAPRS)
 * リース物件元本返済予定表
 */
enum LAPRS {
  summary = '1',
  statement = '2',
}

const nameConfig = {
  summary: new Map([[Locale.ja, 'リース物件元本返済予定表(集計表)']]),
  statement: new Map([[Locale.ja, 'リース物件元本返済予定表(明細表)']]),
};

const toEnum = rawValueToEnum(LAPRS, LAPRS.summary);
const toDisplay = enumToName(LAPRS, nameConfig);
const toDisplayWithPrefix = enumToName(LAPRS, nameConfig, { prefix: true });

export const laprs = {
  enum: LAPRS,
  nameConfig,
  toEnum,
  toDisplay,
  toDisplayWithPrefix,
};
export type { LAPRS };
